import styled from "styled-components";

const NavbarBrand = styled.a`
  box-shadow: ${props => (props.active ? "inset 0 -3px 0 0 white" : false)};
  padding: 15px;
  color: white;
  border: 0;

  &:hover {
    box-shadow: inset 0 -3px 0 #fff;
  }

  &:visited {
    color: white;
  }
`;

export default NavbarBrand;



// WEBPACK FOOTER //
// ./src/UI/Navbar/NavbarLink.js